import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EmailTypes } from 'enum'
import { Notification } from 'models/course.model'
import { determineGrammaticalGender } from 'helpers'
import { useForm } from '../../context'
import styles from '../EmailNotifications.module.scss'
import NotificationChannelRow from './NotificationChannelRow'

interface Props {
  disabled?: boolean
}

const ReminderAutomated: React.FC<Props> = ({ disabled }) => {
  const { t } = useTranslation()
  const { values, setFieldValue } = useForm()

  const defaultValues = useMemo(() => {
    const app = t('commons.navBar.title')
    const context = determineGrammaticalGender(app)
    const options = { app, context }
    return {
      emailSubject: t(
        'administration.courses.new.form.notifications.reminder.default.subject',
        options
      ),
      emailBody: t(
        'administration.courses.new.form.notifications.reminder.default.body',
        options
      ),
    }
  }, [t])

  const value = values.reminderNoStartCourseNotification

  const emailActive = !!value?.active
  const pushActive = !!value?.pushActive

  const onChange = (partial: Partial<Notification>) => {
    setFieldValue('reminderNoStartCourseNotification', {
      active: false,
      pushActive: false,
      emailType: EmailTypes.reminderNoStartCourse,
      ...defaultValues,
      ...value,
      ...partial,
    })
  }

  return (
    <div className={styles.eventBlock}>
      <div className={classNames(styles.eventTitle)}>
        {t('administration.courses.new.form.notifications.reminder.title')}
      </div>
      <NotificationChannelRow
        channel="email"
        checked={emailActive}
        disabled={disabled}
        onChange={(checked) => onChange({ active: checked })}
      />
      <NotificationChannelRow
        channel="mobile"
        checked={pushActive}
        disabled={disabled}
        onChange={(checked) => onChange({ pushActive: checked })}
      />
    </div>
  )
}

export default ReminderAutomated
